
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '30px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '20px 20px 20px 20px', 
      alignItems: 'flex-center',
    },
  },
  title: {
    margin: '0 0 19px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
       alignItems: 'center',
      justifyContent: 'center',
    },
  },
  inputIndent: {
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '20px', 
    },
  }
}));
